<template>
  <div>
    <Row v-for="(column,index) in renderColumn" :key="index" class="expand-row">
      <Col span="24">
        <span class="expand-key">{{column.title}}: </span>
        <span class="expand-value">{{ column.formatter?column.formatter(row[column.key]): row[column.key]}}</span>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: 'table-expand',
  props: {
    row: Object,
    renderColumn: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>

<style scoped>
  .expand-row{
    margin-bottom: 6px;
  }
  td.ivu-table-expanded-cell {
    padding: 2px 2px;
  }
</style>
